import { Component, OnInit } from '@angular/core';

interface feature {
  icon: string;
  title: string;
};

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {

  /**
   * Clients Logo
   */
   featuresdata: feature[] = [
    {
      icon: "cloud",
      title: "Architectures Cloud"
    },
    {
      icon: "git-branch",
      title: "DevOps & CI/CD"
    },
    {
      icon: "cpu",
      title: "Intelligence Artificielle"
    },
    {
      icon: "box",
      title: "Containers & Kubernetes"
    },
    {
      icon: "shield",
      title: "Sécurité Cloud"
    },
    {
      icon: "zap",
      title: "Automatisation IA"
    },
    {
      icon: "activity",
      title: "Monitoring 24/7"
    },
    {
      icon: "layers",
      title: "Microservices"
    },
    {
      icon: "file-text",
      title: "Infrastructure as Code"
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
